import { render, staticRenderFns } from "./TeamAvatar.vue?vue&type=template&id=5b05de7a&scoped=true"
import script from "./TeamAvatar.vue?vue&type=script&lang=js"
export * from "./TeamAvatar.vue?vue&type=script&lang=js"
import style0 from "./TeamAvatar.vue?vue&type=style&index=0&id=5b05de7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b05de7a",
  null
  
)

export default component.exports